/**
 *
 * ReportPeriodicity
 *
 */
import { memo } from 'react';

import { useTranslation } from 'react-i18next';
import { Route, Routes, useParams } from 'react-router-dom';

import { useReportPeriodicity } from '../../services/hooks';

import { ReportPeriodicityForm } from './ReportPeriodicityForm';
import { ReportPeriodicityList } from './ReportPeriodicityList';

interface Props {
  reportId: string;
}

interface EditReportPeriodicity {
  reportId: string;
  reportPeriodicityId: string;
}

const EditReportPeriodicity = () => {
  const { reportId, reportPeriodicityId } = useParams<Record<string, string>>();
  const { data } = useReportPeriodicity(reportId ?? '', reportPeriodicityId ?? '');

  return <>{data && <ReportPeriodicityForm reportId={reportId ?? ''} defaultValue={data} />}</>;
};
// eslint-disable-next-line react/display-name
export const ReportPeriodicity = memo((props: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();
  const { reportId } = props;
  return (
    <>
      <Routes>
        <Route path="" element={<ReportPeriodicityList reportId={reportId} />} />
        <Route
          path="create"
          element={<ReportPeriodicityForm reportId={reportId} defaultValue={{}} />}
        />
        <Route path=":reportPeriodicityId" element={<EditReportPeriodicity />} />
      </Routes>
    </>
  );
});
